document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('upsell-checkbox-input')) return;

    const checkbox = e.target;
    const variantId = checkbox.dataset.variantId;

    const quantityInput = document.querySelector(
        `input[data-cart-quantity-id="${variantId}"]`
    );
    const alreadyInCart = !!quantityInput;

    // ADD TO CART
    if (checkbox.checked && !alreadyInCart) {
        checkbox.disabled = true;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{ id: Number(variantId), quantity: 1 }]
            })
        })
        .then(res => {
            if (!res.ok) throw new Error('Add failed');
            return res.json();
        })
        .then(() => refreshCart())
        .catch(() => checkbox.checked = false)
        .finally(() => checkbox.disabled = false);
    }

    // REMOVE FROM CART (SAFE METHOD)
    else if (!checkbox.checked && alreadyInCart) {
        checkbox.disabled = true;

        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                updates: {
                    [variantId]: 0
                }
            })
        })
        .then(res => {
            if (!res.ok) throw new Error('Remove failed');
            return res.json();
        })
        .then(() => refreshCart())
        .catch(() => checkbox.checked = true)
        .finally(() => checkbox.disabled = false);
    }
});

function refreshCart() {
    
    (async () => {
    console.log('🔄 Updating cart sidebar...');

    // 1️⃣ Fetch current page (sidebar HTML)
    const html = await fetch(location.href).then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const sidebar = doc.querySelector('#halo-cart-sidebar');
    const previewWrapper = sidebar?.querySelector('.previewCart-wrapper');

    if (!previewWrapper) {
        console.error('❌ previewCart-wrapper not found');
        return;
    }

    // 2️⃣ Fetch cart items via AJAX view
    const cartHtml = await fetch('/cart?view=ajax_side_cart').then(r => r.text());
    const cartDoc = new DOMParser().parseFromString(cartHtml, 'text/html');

    // OPTIONAL: adjust selector if needed
    const cartContent = cartDoc.body.innerHTML;

    // 3️⃣ Append cart items
    previewWrapper.innerHTML = cartContent;

    // 4️⃣ Inject updated sidebar into DOM
    const currentSidebar = document.querySelector('#halo-cart-sidebar');
    if (currentSidebar) {
        currentSidebar.innerHTML = sidebar.innerHTML;
        console.log('✅ Cart sidebar fully updated');
    }
    })();

    
}
